import { render } from "./UserPrivacy.vue?vue&type=template&id=5bd01073&scoped=true&ts=true"
import script from "./UserPrivacy.vue?vue&type=script&lang=ts"
export * from "./UserPrivacy.vue?vue&type=script&lang=ts"

import "./UserPrivacy.vue?vue&type=style&index=0&id=5bd01073&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd01073"]])

export default __exports__